var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 341.33,
    style: {
      fill: "#FF4B55"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    style: {
      fill: "#FFE15A"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.622,
    y: 286.616,
    transform: "matrix(-0.775 0.6319 -0.6319 -0.775 687.166 360.2627)",
    style: {
      fill: "#FFCD5A"
    },
    width: 5.666,
    height: 31.668
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.192,
    y: 288.607,
    transform: "matrix(-0.7753 0.6316 -0.6316 -0.7753 672.8622 351.7662)",
    style: {
      fill: "#FFBE5A"
    },
    width: 11.33,
    height: 13.937
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.144,
    y: 286.624,
    transform: "matrix(0.775 0.6319 -0.6319 0.775 243.993 -80.4436)",
    style: {
      fill: "#FFCD5A"
    },
    width: 5.666,
    height: 31.668
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.915,
    y: 288.602,
    transform: "matrix(0.7753 0.6316 -0.6316 0.7753 240.7408 -85.5337)",
    style: {
      fill: "#FFBE5A"
    },
    width: 11.33,
    height: 13.937
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "250.14,297.586 235.976,325.913 255.805,340.076 255.805,300.419 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCD5A"
    },
    points: "261.471,297.586 275.634,325.913 255.805,340.076 255.805,300.419 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M216.148,297.586v-73.65h8.498c0,0,0,48.156,0,56.654  C224.646,289.088,216.148,297.586,216.148,297.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M210.482,311.75v-87.813h8.498c0,0,0,62.319,0,70.817S210.482,311.75,210.482,311.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M204.817,323.08v-99.144h8.498c0,0,0,73.65,0,82.148C213.315,314.582,204.817,323.08,204.817,323.08z  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M224.646,226.769c0,0,0,40.366,0,53.821c0,14.163,20.537,12.275,31.16,22.661  c10.623-10.387,31.16-8.498,31.16-22.661c0-13.455,0-53.821,0-53.821H224.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M224.646,257.929c0,8.967,0,17.668,0,22.661c0,14.163,20.537,12.275,31.16,22.661  c10.623-10.387,31.16-8.498,31.16-22.661c0-4.993,0-13.694,0-22.661H224.646z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "255.805,294.754 247.307,289.088 247.307,286.255 250.14,283.423 250.14,266.427    241.642,260.761 250.14,249.431 252.972,249.431 255.805,252.263 258.638,249.431 261.471,249.431 269.969,260.761    261.471,266.427 261.471,283.423 264.303,286.255 264.303,289.088  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M244.474,229.602c0,0-11.331,2.833-11.331,14.163s11.331,16.996,11.331,16.996l5.665-8.498   C233.144,246.598,244.474,229.602,244.474,229.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M267.136,229.602c0,0,11.331,2.833,11.331,14.163s-11.331,16.996-11.331,16.996l-5.665-8.498   C278.467,246.598,267.136,229.602,267.136,229.602z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "227.478,257.929 233.144,260.761 238.809,257.929 233.144,255.096  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "272.801,257.929 278.467,260.761 284.132,257.929 278.467,255.096  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "255.805,231.018 257.865,233.127 260.813,233.092 260.778,236.04 262.887,238.1    260.778,240.159 260.813,243.107 257.865,243.072 255.805,245.182 253.745,243.072 250.798,243.107 250.833,240.159 248.723,238.1    250.833,236.04 250.798,233.092 253.745,233.127  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M236.569,270.299l2.043,2.272l2.84-1.126c1.47-0.583,2.851,1.017,2.059,2.386l-1.53,2.645   l1.949,2.353c1.009,1.218-0.086,3.026-1.633,2.696l-2.988-0.637l-1.636,2.581c-0.847,1.336-2.904,0.853-3.068-0.72l-0.317-3.039   l-2.96-0.759c-1.532-0.393-1.709-2.498-0.263-3.141l2.792-1.241l-0.193-3.049C233.563,269.941,235.511,269.123,236.569,270.299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M274.298,276.758c0.625-3.222,3.283-5.503,6.383-5.847c-0.635-0.342-1.312-0.624-2.057-0.769   c-3.968-0.769-7.808,1.823-8.577,5.791s1.823,7.808,5.791,8.577c0.745,0.145,1.478,0.135,2.195,0.056   C275.286,283.089,273.673,279.98,274.298,276.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M244.474,226.769l5.665-28.327l-11.331-8.498l2.833-2.833h5.665c0,0,2.833-2.833,8.498-2.833   s11.331,2.833,11.331,11.331s2.833,31.16,2.833,31.16L244.474,226.769L244.474,226.769z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA5A"
    },
    d: "M224.646,215.438c-6.258,0-11.331,5.073-11.331,11.331h22.661  C235.976,220.511,230.903,215.438,224.646,215.438z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M221.813,226.769h-16.996v-18.855c0-3.667,2.973-6.64,6.64-6.64h3.717c3.667,0,6.64,2.973,6.64,6.64   L221.813,226.769L221.813,226.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M295.463,297.586v-73.65h-8.498c0,0,0,48.156,0,56.654   C286.965,289.088,295.463,297.586,295.463,297.586z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD5A"
    },
    d: "M301.128,311.75v-87.813h-8.498c0,0,0,62.319,0,70.817S301.128,311.75,301.128,311.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M306.793,323.08v-99.144h-8.498c0,0,0,73.65,0,82.148C298.295,314.582,306.793,323.08,306.793,323.08  z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA5A"
    },
    d: "M286.965,215.438c6.258,0,11.331,5.073,11.331,11.331h-22.661  C275.634,220.511,280.707,215.438,286.965,215.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M289.797,226.769h16.996v-18.855c0-3.667-2.973-6.64-6.64-6.64h-3.717c-3.667,0-6.64,2.973-6.64,6.64  v18.855H289.797z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.825,
    y: 252.362,
    transform: "matrix(0.8541 0.5201 -0.5201 0.8541 194.9956 -114.1423)",
    style: {
      fill: "#FFAA5A"
    },
    width: 4.249,
    height: 76.27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.411,
    y: 308.806,
    transform: "matrix(-0.6244 0.7811 -0.7811 -0.6244 712.6194 283.8)",
    style: {
      fill: "#FFE15A"
    },
    width: 11.331,
    height: 8.855
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.972,
    y: 256.741,
    transform: "matrix(0.8542 0.5199 -0.5199 0.8542 183.8729 -125.9396)",
    style: {
      fill: "#FFCD5A"
    },
    width: 7.082,
    height: 16.344
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 176.236,
    y: 290.331,
    transform: "matrix(0.5429 0.8398 -0.8398 0.5429 342.3993 -45.5703)",
    style: {
      fill: "#73AF00"
    },
    width: 73.65,
    height: 2.833
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M219.413,289.386c-1.016,1.152-1.69,2.898-1.86,4.913c-1.397-1.41-3.001-2.309-4.496-2.549   c-0.394,1.461-0.234,3.293,0.479,5.146c-1.906-0.672-3.775-0.774-5.243-0.321c0.413,2.087,2.114,4.354,4.721,5.909   c2.607,1.556,5.409,1.976,7.442,1.348l0.581-0.376c1.407-1.596,2.174-4.324,1.826-7.34   C222.515,293.101,221.147,290.62,219.413,289.386z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF4B55"
    },
    cx: 220.75,
    cy: 303.64,
    r: 2.833
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M208.648,272.734c-1.016,1.152-1.69,2.898-1.86,4.913c-1.397-1.41-3.001-2.309-4.496-2.549  c-0.394,1.461-0.234,3.293,0.479,5.146c-1.906-0.672-3.775-0.774-5.243-0.321c0.413,2.087,2.114,4.354,4.721,5.909  c2.607,1.556,5.409,1.976,7.442,1.348l0.581-0.376c1.407-1.596,2.174-4.324,1.826-7.34  C211.75,276.448,210.382,273.967,208.648,272.734z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF4B55"
    },
    cx: 209.98,
    cy: 286.99,
    r: 2.833
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M197.883,256.081c-1.016,1.152-1.69,2.898-1.86,4.913c-1.397-1.41-3.001-2.309-4.496-2.549  c-0.394,1.461-0.234,3.293,0.479,5.146c-1.906-0.672-3.775-0.774-5.243-0.321c0.413,2.087,2.114,4.354,4.721,5.909  c2.607,1.556,5.409,1.976,7.442,1.348l0.581-0.376c1.407-1.596,2.174-4.324,1.826-7.34  C200.986,259.796,199.617,257.315,197.883,256.081z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF4B55"
    },
    cx: 199.22,
    cy: 270.34,
    r: 2.833
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 220.705,
    y: 308.815,
    transform: "matrix(0.6244 0.7811 -0.7811 0.6244 329.6991 -59.1658)",
    style: {
      fill: "#FFE15A"
    },
    width: 11.331,
    height: 8.855
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.81,
    y: 178.61,
    style: {
      fill: "#FFE15A"
    },
    width: 2.833,
    height: 19.829
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.98,
    y: 181.45,
    style: {
      fill: "#FFE15A"
    },
    width: 8.498,
    height: 2.833
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF875A"
    },
    points: "238.809,189.944 247.307,196.318 247.307,187.111 241.642,187.111 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA5A"
    },
    d: "M241.642,178.613v2.833h2.833v2.833h-2.833v2.833h5.665c0,0,2.833-2.833,8.498-2.833  s11.331,2.833,11.331,11.331s2.833,31.16,2.833,31.16h5.665c0-6.258,5.073-11.331,11.331-11.331c0.984,0,1.922,0.165,2.833,0.401  v-6.066c0-4.693,3.805-8.498,8.498-8.498s8.498,3.805,8.498,8.498v14.163v2.833v50.026l3.658-6.01l-1.21-0.736l8.498-13.961  l1.21,0.736v-0.001l1.815,1.105l3.025,1.841l-8.498,13.961l-1.21-0.737l-7.288,11.973v38.113c0,0-6.765-6.783-8.212-14.288  c-1.035-1.33-2.227-3.026-3.276-4.952l-3.242,5.326l3.014,2.409l-7.075,8.851l-1.879-1.502l-3.202,5.261l-3.629-2.21l3.485-5.726  l-1.692-1.352l2.409-3.014l-7.433-9.115l-2.196,1.789l-6.609-8.111c-1.759,0.708-3.498,1.484-5.171,2.372l13.547,27.095  l-19.829,14.163l-19.829-14.163l13.547-27.095c-1-0.53-2.016-1.034-3.056-1.491l-5.891,7.23l-2.196-1.789l-7.433,9.115l2.409,3.014  l-2.406,1.923l3.288,5.086l-2.379,1.538l-3.133-4.846l-2.287,1.828l-7.075-8.851l3.179-2.541l-1.685-2.607  c-0.04,0.002-0.08,0.002-0.119,0.002c-0.925,0-1.833-0.413-2.372-1.248c-0.23-0.355-0.354-0.742-0.41-1.135  c-0.533-0.032-1.073-0.109-1.635-0.242c-1.053,1.941-2.253,3.65-3.294,4.988c-1.447,7.505-8.212,14.288-8.212,14.288v-36.132  c-0.856-0.269-1.719-0.611-2.568-1.117c-2.607-1.555-4.307-3.822-4.721-5.909c0.596-0.184,1.257-0.276,1.961-0.276  c1.03,0,2.149,0.198,3.282,0.597c-0.369-0.96-0.583-1.91-0.656-2.81l-2.786-4.31c-0.04,0.002-0.079,0.002-0.119,0.002  c-0.926,0-1.832-0.413-2.372-1.248c-0.23-0.355-0.354-0.742-0.41-1.136c-1.568-0.094-3.286-0.573-4.944-1.563  c-2.607-1.555-4.307-3.822-4.721-5.909c0.596-0.184,1.257-0.276,1.961-0.276c1.03,0,2.149,0.198,3.282,0.597  c-0.712-1.853-0.873-3.685-0.479-5.146c1.494,0.24,3.099,1.139,4.496,2.549c0.17-2.014,0.844-3.76,1.86-4.913  c1.734,1.234,3.102,3.715,3.45,6.731c0.221,1.918-0.046,3.682-0.605,5.15c0.335,0.212,0.637,0.485,0.867,0.84  c0.563,0.871,0.543,1.918,0.113,2.783l2.786,4.31c0.108,0.06,0.214,0.133,0.322,0.198v-49.324v-2.833v-14.163  c0-4.693,3.805-8.498,8.498-8.498c4.693,0,8.498,3.805,8.498,8.498v6.066c0.91-0.236,1.849-0.401,2.833-0.401  c6.258,0,11.331,5.073,11.331,11.331h8.498l5.665-28.327l-2.833-2.125l-5.665-4.249v6.374h-2.833v-14.163h-2.833v-2.833h2.833  v-2.833L241.642,178.613 M287.114,307.356l1.047-1.309l0.557,0.445l4.566-7.501c-0.399-1.387-0.653-2.81-0.653-4.237  c0-0.139,0-0.33,0-0.498c-2.472-3.251-5.665-8.454-5.665-13.666c0,5.966-3.662,9.074-8.674,11.461l4.359,5.35l-2.195,1.788  L287.114,307.356 M224.769,307.256l1.514-1.21l1.047,1.309l6.659-8.166l-2.195-1.788l3.604-4.424  c-6.051-2.527-10.752-5.623-10.752-12.387c0,3.792-1.693,7.579-3.567,10.616c0.89,1.306,1.562,2.976,1.785,4.911  c0.221,1.918-0.046,3.682-0.605,5.15c0.335,0.212,0.637,0.485,0.867,0.84c0.563,0.871,0.543,1.917,0.113,2.783L224.769,307.256   M241.642,176.489h-2.833c-1.173,0-2.125,0.951-2.125,2.125v0.708h-0.708c-1.173,0-2.125,0.951-2.125,2.125v2.833  c0,1.173,0.951,2.125,2.125,2.125h0.708v12.039c0,1.173,0.951,2.125,2.125,2.125h2.833c1.173,0,2.125-0.951,2.125-2.125v-2.125  l2.266,1.7l1.762,1.321l-5.061,25.306h-4.799c-1.022-6.413-6.591-11.331-13.288-11.331c-0.235,0-0.471,0.007-0.708,0.022v-3.563  c0-5.857-4.765-10.623-10.623-10.623s-10.623,4.765-10.623,10.623v14.163v2.833v32.578c-0.767-2.116-2.014-3.885-3.577-4.997  c-0.372-0.265-0.803-0.394-1.231-0.394c-0.592,0-1.177,0.246-1.595,0.72c-0.654,0.742-1.192,1.647-1.593,2.667  c-0.93-0.505-1.887-0.844-2.831-0.996c-0.114-0.018-0.227-0.027-0.339-0.027c-0.945,0-1.796,0.632-2.049,1.571  c-0.249,0.922-0.332,1.935-0.254,2.989c-0.167-0.008-0.333-0.012-0.498-0.012c-0.92,0-1.79,0.125-2.588,0.371  c-1.04,0.321-1.669,1.375-1.458,2.442c0.549,2.777,2.686,5.514,5.716,7.321c1.398,0.834,2.916,1.406,4.457,1.685  c0.062,0.117,0.129,0.231,0.201,0.342c0.698,1.079,1.791,1.82,3.042,2.098l1.548,2.394c-0.052-0.001-0.103-0.001-0.154-0.001  c-0.92,0-1.79,0.125-2.588,0.371c-1.039,0.321-1.669,1.375-1.457,2.442c0.549,2.777,2.686,5.514,5.716,7.321  c0.485,0.289,0.988,0.545,1.532,0.776v34.649c0,0.86,0.518,1.635,1.313,1.963c0.262,0.108,0.538,0.161,0.811,0.161  c0.554,0,1.098-0.217,1.505-0.624c0.289-0.29,6.952-7.042,8.688-14.879c0.714-0.939,1.374-1.886,1.974-2.833  c0.684,0.79,1.609,1.335,2.643,1.564l0.091,0.141l-1.679,1.342c-0.44,0.352-0.722,0.864-0.785,1.424  c-0.062,0.56,0.1,1.122,0.452,1.562l7.075,8.851c0.352,0.44,0.864,0.722,1.424,0.785c0.078,0.009,0.157,0.013,0.235,0.013  c0.48,0,0.948-0.163,1.326-0.465l0.452-0.361l1.857,2.873c0.306,0.473,0.787,0.806,1.338,0.924c0.148,0.032,0.297,0.047,0.446,0.047  c0.406,0,0.807-0.116,1.154-0.34l1.374-0.888l-0.312,0.623c-0.467,0.935-0.185,2.071,0.665,2.679l19.829,14.163  c0.369,0.264,0.802,0.396,1.235,0.396s0.866-0.132,1.235-0.396l19.829-14.163c0.851-0.608,1.133-1.744,0.665-2.679l-12.597-25.195  c0.534-0.252,1.091-0.502,1.674-0.753l5.609,6.883c0.42,0.515,1.032,0.783,1.648,0.783c0.472,0,0.946-0.156,1.341-0.477l0.55-0.448  l5.007,6.14l-1.338,1.674c-0.352,0.44-0.514,1.002-0.452,1.562c0.063,0.56,0.345,1.072,0.785,1.424l0.232,0.185l-2.513,4.129  c-0.61,1.002-0.292,2.309,0.71,2.919l3.629,2.21c0.336,0.204,0.718,0.31,1.105,0.31c0.168,0,0.336-0.02,0.502-0.06  c0.548-0.133,1.02-0.478,1.313-0.96l1.947-3.199c0.39,0.309,0.856,0.459,1.318,0.459c0.624,0,1.241-0.273,1.661-0.798l7.075-8.851  c0.26-0.326,0.409-0.705,0.452-1.091c2.309,6.903,7.838,12.506,8.1,12.769c0.407,0.408,0.951,0.624,1.505,0.624  c0.273,0,0.549-0.053,0.811-0.161c0.795-0.328,1.313-1.104,1.313-1.963v-37.517l5.936-9.753c0.144,0.03,0.29,0.045,0.435,0.045  c0.717,0,1.417-0.363,1.817-1.02l8.498-13.961c0.293-0.481,0.383-1.059,0.25-1.607c-0.133-0.547-0.478-1.02-0.96-1.313l-3.025-1.841  l-1.814-1.105l-1.212-0.737c-0.345-0.21-0.726-0.309-1.102-0.309c-0.717,0-1.417,0.363-1.817,1.02l-7.007,11.512v-39.726v-2.833  V209.77c0-5.857-4.765-10.623-10.623-10.623c-5.857,0-10.623,4.765-10.623,10.623v3.563c-0.238-0.015-0.473-0.022-0.708-0.022  c-6.697,0-12.266,4.917-13.288,11.331h-1.827c-0.669-5.576-2.59-22.173-2.59-29.035c0-9.921-6.951-13.455-13.455-13.455  c-4.816,0-7.925,1.836-9.258,2.833h-0.069c0.078-0.221,0.121-0.46,0.121-0.708v-2.833c0-1.173-0.951-2.125-2.125-2.125h-0.708  v-0.708C243.766,177.44,242.815,176.489,241.642,176.489L241.642,176.489z M223.55,291.202c0.544-0.957,1.019-1.901,1.426-2.831  c1.771,2.376,4.319,4.067,7.031,5.405l-1.86,2.283c-0.356,0.437-0.524,0.997-0.467,1.558s0.335,1.076,0.772,1.431l0.547,0.445  l-3.785,4.643c-0.216-0.105-0.451-0.174-0.695-0.201c-0.079-0.009-0.157-0.013-0.235-0.013c-0.211,0-0.421,0.032-0.621,0.093  c0.097-1.069-0.156-2.14-0.752-3.062c-0.072-0.111-0.149-0.219-0.23-0.324c0.378-1.519,0.48-3.138,0.294-4.756  C224.782,294.212,224.295,292.621,223.55,291.202L223.55,291.202z M281.58,292.725c1.871-1.092,3.688-2.473,5.066-4.33  c1.084,2.477,2.511,4.73,3.861,6.569c0.017,1.183,0.178,2.401,0.491,3.695l-3.225,5.299c-0.187,0.035-0.37,0.094-0.543,0.178  l-3.785-4.642l0.547-0.445c0.437-0.356,0.714-0.871,0.772-1.431c0.057-0.561-0.111-1.121-0.467-1.558L281.58,292.725L281.58,292.725  z M240.576,306.682c0.617,0,1.228-0.267,1.648-0.783l3.582-4.397l-9.697,19.395c-0.026-0.049-0.055-0.097-0.086-0.145l-2.245-3.472  l0.905-0.724c0.44-0.352,0.723-0.864,0.785-1.424s-0.1-1.122-0.452-1.562l-1.338-1.674l5.007-6.14l0.55,0.448  C239.629,306.525,240.104,306.682,240.576,306.682L240.576,306.682z M294.851,308.674l0.463-0.76  c0.407,0.598,0.836,1.194,1.287,1.788c0.04,0.179,0.082,0.357,0.126,0.534c-0.094-0.116-0.202-0.223-0.323-0.32L294.851,308.674  L294.851,308.674z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMd);
export default __webpack_public_path__ + "static/media/MD.b70e464a998f3a274230a690da3cd774.svg";
export { ForwardRef as ReactComponent };